import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { allHostsAreSelected, someHostIsSelected } from 'store/HostsGeneral/selectors';
import { selectAllHost } from 'store/HostsGeneral/actions';
import SelectionHeader from 'shared/ui/Table/cells/SelectionHeader';

export const CheckHeader = () => { // eslint-disable-line import/prefer-default-export
  const allHostSelected = useSelector(allHostsAreSelected);
  const someHostSelected = useSelector(someHostIsSelected);
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(selectAllHost());
  };

  return (
    <SelectionHeader onChange={ handleClick } checked={ allHostSelected } indeterminate={ someHostSelected && !allHostSelected } />
  );
};
